import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getMergedHomes, getAvailableBintiTags } from "./services/soar";
import Select from "./common/Select";
import RadioButton from "./common/RadioButton";
import { Multiselect } from "react-widgets";
import DynamicHome from "./pipeline/DynamicHome";
import AddApplication from "./pipeline/AddApplication";
import ExpandDiv from "./common/ExpandDiv";

function SAFYHomes() {
  const [selectedState, setSelectedState] = useState("");
  const [assignment, setAssignment] = useState("state");
  const [groupedData, setGroupedData] = useState([]);
  const [filterType, setFilterType] = useState("applying");
  const [sortType, setSortType] = useState("newest");
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [allStatuses, setAllStatuses] = useState(false);
  const [additionalFilters, setAdditionalFilters] = useState([]);
  const [tagFilters, setTagFilters] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [loading, setLoading] = useState();
  const [refreshData, setRefreshData] = useState(false);
  const [ypos, setYpos] = useState(null);

  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    if (
      safyInfo?.user &&
      safyInfo.user.safyInfo.BusinessUnitIdName !== "ccplive"
    )
      setSelectedState(
        safyInfo.user.safyInfo.BusinessUnitIdName.toLowerCase()
          .replace("safy of ", "")
          .replace(" ", "")
      );
  }, [safyInfo]);

  useEffect(() => {
    if (selectedState !== "") {
      setLoading(true);
      setGroupedData([]);
      setRefreshData(false);
      getMergedHomes(selectedState).then((response) => {
        if (response && response !== "") {
          const allApps = JSON.parse(response);
          allApps.sort((a, b) =>
            a.HomeData[0].createdon < b.HomeData[0].createdon ? 1 : -1
          );
          setGroupedData(allApps);
        }

        setLoading(false);

        if (ypos) {
          setTimeout(() => {
            window.scrollTo(0, ypos);
            setYpos(null);
          }, 1000);
        }
      });
      //call available tags
      getAvailableBintiTags(selectedState).then((response) => {
        if (response && response !== "") {
          const allTags = JSON.parse(response).tags;
          //console.log("TAGS", allTags);
          const tags = allTags.map((t) => t.tag);
          setAvailableTags(tags);
        }
      });
    }
  }, [selectedState, refreshData === true]);

  const filters = useCallback(
    (data) => {
      let filteredHomes = data;
      if (selectedPeople.length > 0) {
        let homes = [...data];
        let mutliPersonApps = [];
        selectedPeople.forEach((p) => {
          const pHomes = homes.filter((app) => {
            if (mutliPersonApps.includes(app)) {
              return false;
            }

            const workerJSON =
              app.HomeData[0] && app.HomeData[0].workers
                ? JSON.stringify(app.HomeData[0].workers)
                : "";

            if (
              workerJSON.includes(p) ||
              // app.HomeData[0].tags?.includes(p) ||
              app.HomeData[0].fostercarehomename?.includes(p)
            ) {
              return true;
            }

            return false;
          });
          mutliPersonApps.push(...pHomes);
        });
        filteredHomes = mutliPersonApps;
      }

      if (assignment === "unassigned") {
        filteredHomes = filteredHomes.filter(
          (app) => app.HomeData[0] && app.HomeData[0].workers.length === 0
        );
      }

      if (assignment === "my" && safyInfo?.user) {
        filteredHomes = filteredHomes.filter((app) =>
          app.HomeData[0] &&
          app.HomeData[0].workers.filter(
            (w) => w.worker_name === safyInfo.user.displayName
          ).length > 0
            ? app
            : null
        );
      }

      if (additionalFilters.includes("NCD-PAST")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0]?.next_contact[0]?.case_note_date &&
            new Date() >
              new Date(app.HomeData[0].next_contact[0].case_note_date)
        );
      }

      if (additionalFilters.includes("NCD-7")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0]?.next_contact[0]?.case_note_date &&
            new Date() <
              new Date(app.HomeData[0].next_contact[0].case_note_date) &&
            new Date(app.HomeData[0].next_contact[0].case_note_date) <
              new Date(new Date().setDate(new Date().getDate() + 7))
        );
      }

      if (additionalFilters.includes("LCD-30")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0]?.last_contact[0]?.case_note_date &&
            new Date(app.HomeData[0].last_contact[0].case_note_date) <
              new Date(new Date().setDate(new Date().getDate() - 30))
        );
      }

      if (additionalFilters.includes("NOLCD")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0]?.last_contact[0]?.case_note_date === undefined
        );
      }

      if (additionalFilters.includes("TRAINING")) {
        filteredHomes = filteredHomes.filter(
          (app) => app.HomeData[0]?.last_attended_training.length > 0
        );
      }

      if (additionalFilters.includes("ALD-PAST30")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0] &&
            (app.HomeData[0].status === "applying" ||
              app.HomeData[0].status === "recruiting") &&
            app.HomeData[0].approval_date_estimate[0]?.case_note_date &&
            new Date() >
              new Date(
                app.HomeData[0].approval_date_estimate[0].case_note_date
              ) &&
            new Date(app.HomeData[0].approval_date_estimate[0].case_note_date) >
              new Date(new Date().setDate(new Date().getDate() - 30))
        );
      }

      if (additionalFilters.includes("ALD-30")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0] &&
            (app.HomeData[0].status === "applying" ||
              app.HomeData[0].status === "recruiting") &&
            app.HomeData[0].approval_date_estimate[0]?.case_note_date &&
            new Date() <
              new Date(
                app.HomeData[0].approval_date_estimate[0].case_note_date
              ) &&
            new Date(app.HomeData[0].approval_date_estimate[0].case_note_date) <
              new Date(new Date().setDate(new Date().getDate() + 30))
        );
      }

      if (additionalFilters.includes("RECERT-60")) {
        filteredHomes = filteredHomes.filter(
          (app) =>
            app.HomeData[0]?.renewaldate &&
            new Date() < new Date(app.HomeData[0].renewaldate) &&
            new Date(app.HomeData[0].renewaldate) <
              new Date(new Date().setDate(new Date().getDate() + 60))
        );
      }

      if (tagFilters.length > 0) {
        console.log("tagFilters", tagFilters);
        filteredHomes = filteredHomes.filter((app) => {
          return tagFilters.every((t) => app.HomeData[0].tags.includes(t));
        });
      }

      //sort filteredHomes by sortType
      if (sortType === "newest") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0].createdon < b.HomeData[0].createdon ? 1 : -1
        );
      }

      if (sortType === "nameAscending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0].fostercarehomename < b.HomeData[0].fostercarehomename
            ? -1
            : 1
        );
      }

      if (sortType === "nameDescending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0].fostercarehomename > b.HomeData[0].fostercarehomename
            ? -1
            : 1
        );
      }

      if (sortType === "lastContactDateAscending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.last_contact[0]?.case_note_date <
          b.HomeData[0]?.last_contact[0]?.case_note_date
            ? -1
            : 1
        );
      }

      if (sortType === "lastContactDateDescending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.last_contact[0]?.case_note_date >
          b.HomeData[0]?.last_contact[0]?.case_note_date
            ? -1
            : 1
        );
      }

      if (sortType === "daysInStatusAscending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.statusdate < b.HomeData[0]?.statusdate ? -1 : 1
        );
      }

      if (sortType === "daysInStatusDescending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.statusdate > b.HomeData[0]?.statusdate ? -1 : 1
        );
      }

      if (sortType === "daysSinceInquiryAscending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.inquirydate < b.HomeData[0]?.inquirydate ? -1 : 1
        );
      }

      if (sortType === "daysSinceInquiryDescending") {
        filteredHomes.sort((a, b) =>
          a.HomeData[0]?.inquirydate > b.HomeData[0]?.inquirydate ? -1 : 1
        );
      }

      return filteredHomes;
    },
    [selectedPeople, assignment, additionalFilters, safyInfo, sortType]
  );

  const filterCount = (filter) => {
    const filteredHomes = filters([...groupedData]);

    return `${filter} ${
      filter === "In Renewal"
        ? filteredHomes.filter(
            (app) =>
              app.HomeData[0] &&
              `${app.HomeData[0].type}${app.HomeData[0].status}` ===
                "RenewalApplicationapplying"
          ).length
        : filteredHomes.filter(
            (app) =>
              app &&
              app.HomeData &&
              app.HomeData[0] &&
              `${app.HomeData[0].type}${app.HomeData[0].status}` !==
                "RenewalApplicationapplying" &&
              // ((app.SoarData[0] &&
              //   app.SoarData[0].status.toLowerCase() ===
              //     filter.toLowerCase()) ||
              app.HomeData[0] &&
              app.HomeData[0].status.toLowerCase() === filter.toLowerCase()
          ).length
    }`;
  };

  // const handleSearch = ({ currentTarget: input }) => {
  //   setSearchQuery(input.value);
  // };

  const filteredData = useMemo(() => {
    let filteredHomes = groupedData.filter(
      (app) =>
        (filterType &&
          filterType !== "In Renewal" &&
          app.HomeData[0] &&
          app.HomeData[0].status.toLowerCase() === filterType.toLowerCase() &&
          app.HomeData[0] &&
          `${app.HomeData[0].type}${app.HomeData[0].status}` !==
            "RenewalApplicationapplying") ||
        (app.HomeData[0] &&
          filterType === "In Renewal" &&
          `${app.HomeData[0].type}${app.HomeData[0].status}` ===
            "RenewalApplicationapplying")
    );

    return filters(filteredHomes);
  }, [groupedData, filterType, filters]);

  const searchData = useMemo(() => {
    const applicants = [];
    const workers = [];
    // const tags = [];
    groupedData.forEach((app) => {
      if (!applicants.includes(app.HomeData[0].fostercarehomename)) {
        applicants.push(app.HomeData[0].fostercarehomename);
      }

      if (
        app.HomeData[0] &&
        JSON.stringify(app.HomeData[0].workers) !== "[{}]"
      ) {
        app.HomeData[0].workers.forEach((w) => {
          if (!workers.includes(w.worker_name)) {
            workers.push(w.worker_name);
          }
        });
      }

      // if (
      //   app.HomeData[0].tags &&
      //   JSON.stringify(app.HomeData[0].tags) !== "[]"
      // ) {
      //   app.HomeData[0].tags.forEach((tag) => {
      //     if (!tags.includes(tag)) {
      //       tags.push(tag);
      //     }
      //   });
      // }

      // app.HomeData.forEach((home) => {
      //   if (home.workers?.forEach) {
      //     home.workers.forEach((worker) => {
      //       if (!workers.includes(worker.worker_name)) {
      //         workers.push(worker.worker_name);
      //       }
      //     });
      //   }
      // });
    });

    const applicantOptions = applicants.map((applicant) => {
      return { _id: applicant, name: applicant, type: "Applicant" };
    });
    const workerOptions = workers.map((worker) => {
      return { _id: worker, name: worker, type: "Worker" };
    });
    // const tagOptions = tags.map((tag) => {
    //   return { _id: tag, name: tag, type: "Tag" };
    // });

    return applicantOptions.concat(workerOptions);
  }, [groupedData]);

  const filterPeople = (person, searchString) => {
    if (!person.name) {
      return false;
    }

    const valueToCompare = person.name.toUpperCase();
    return valueToCompare.includes(searchString.toUpperCase());
  };

  const getAdditionalFilterClass = (item) => {
    return additionalFilters.includes(item)
      ? "btn btn-sm btn-success m-1"
      : "btn btn-sm btn-safy-info m-1";
  };
  const getTagFilterClass = (item) => {
    return tagFilters.includes(item)
      ? "btn btn-sm btn-success m-1"
      : "btn btn-sm btn-safy-info m-1";
  };

  const addRemoveAdditionalFilter = (item) => {
    const af = [...additionalFilters];
    const index = af.indexOf(item);

    if (index === -1) {
      af.push(item);
    } else {
      af.splice(index, 1);
    }
    setAdditionalFilters(af);
  };

  const addRemoveTagFilter = (item) => {
    const tf = [...tagFilters];
    const index = tf.indexOf(item);

    if (index === -1) {
      tf.push(item);
    } else {
      tf.splice(index, 1);
    }
    setTagFilters(tf);
  };

  const clearStatusRelatedFilters = () => {
    const af = [...additionalFilters];
    if (af.indexOf("ALD-PAST30") !== -1) {
      af.splice(af.indexOf("ALD-PAST30"));
    }
    if (af.indexOf("ALD-30") !== -1) {
      af.splice(af.indexOf("ALD-30"));
    }
    if (af.indexOf("RECERT-60") !== -1) {
      af.splice(af.indexOf("RECERT-60"));
    }
    setAdditionalFilters(af);
  };

  return (
    <>
      <div className="h3">New Foster Home Experience</div>
      {process.env.REACT_APP_ENVIRONMENT !== "Production" && (
        <div className="bg-danger text-white my-4 p-4">
          THIS PROTOTYPE IS CONNECTED TO LIVE BINTI DATA <br />
          This module is currently under development and is for testing READING
          permissions between Binti and SOAR data. This has connections to the
          Live Binti system. Please do not add/modify any information at this
          time.
        </div>
      )}
      {JSON.stringify(safyInfo.user.safyInfo.binti) === "[{}]" ? (
        <div className="bg-danger text-white my-4 p-4">
          User does not have any Binti Worker ID. Case Note creation will be
          restricted
        </div>
      ) : null}
      {safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
      safyInfo.user.modules.includes("Admin") ? (
        <div className="rounded bg-warning p-2">
          <Select
            className="col-12 col-md-6"
            name="stateSelection"
            label="Select State"
            onChange={(e) => {
              setLoading(true);
              setSelectedState(e.currentTarget.value);
            }}
            options={[
              { name: "Alabama", _id: "alabama" },
              { name: "Colorado", _id: "colorado" },
              { name: "Indiana", _id: "indiana" },
              { name: "Kentucky", _id: "kentucky" },
              { name: "Nevada", _id: "nevada" },
              { name: "Ohio", _id: "ohio" },
              { name: "South Carolina", _id: "southcarolina" },
            ]}
            value={selectedState}
          ></Select>
        </div>
      ) : null}
      {loading === true ? (
        <div className="h2 text-safy-success m-4">Loading Data</div>
      ) : null}

      {groupedData && groupedData.length > 0 ? (
        <>
          <div className="mt-4 border border-dark rounded p-2 bg-light">
            <div className="mt-2">Filter by Assignment</div>
            <div>
              <RadioButton
                name="assignment"
                label=""
                options={[
                  { name: "State", _id: "state" },
                  { name: "My Homes", _id: "my" },
                  { name: "Unassigned", _id: "unassigned" },
                ]}
                value={assignment}
                onChange={(e) => setAssignment(e.currentTarget.value)}
              />
              <div className="mt-2">Filter by Applicant or Worker</div>
              <Multiselect
                name="ConcurrentServicesList"
                data={searchData}
                dataKey="_id"
                textField="name"
                value={selectedPeople}
                onChange={(people) => {
                  setSelectedPeople(people.map((a) => a._id));
                }}
                busy={loading}
                filter={filterPeople}
                groupBy="type"
              />
            </div>
            <div className="mt-2">Filter by Status</div>
            <div className="d-flex flex-wrap">
              <button
                className={
                  filterType === "applying"
                    ? "btn btn-sm btn-success me-2 mb-2"
                    : "btn btn-sm btn-safy-info me-2 mb-2"
                }
                onClick={() => {
                  clearStatusRelatedFilters();
                  setFilterType("applying");
                }}
              >
                {filterCount("Applying")}
              </button>
              <button
                className={
                  filterType === "recruiting"
                    ? "btn btn-sm btn-success me-2 mb-2"
                    : "btn btn-sm btn-safy-info me-2 mb-2"
                }
                onClick={() => {
                  clearStatusRelatedFilters();
                  setFilterType("recruiting");
                }}
              >
                {filterCount("Recruiting")}
              </button>
              <button
                className={
                  filterType === "In Renewal"
                    ? "btn btn-sm btn-success me-2 mb-2"
                    : "btn btn-sm btn-safy-info me-2 mb-2"
                }
                onClick={() => {
                  clearStatusRelatedFilters();
                  setFilterType("In Renewal");
                }}
              >
                {filterCount("In Renewal")}
              </button>
              {allStatuses === true ? (
                <>
                  <button
                    className={
                      filterType === "recruiting_dropout"
                        ? "btn btn-sm btn-success me-2 mb-2"
                        : "btn btn-sm btn-safy-info me-2 mb-2"
                    }
                    onClick={() => {
                      clearStatusRelatedFilters();
                      setFilterType("recruiting_dropout");
                    }}
                  >
                    {`Recruiting Dropout (${
                      groupedData.filter(
                        (app) => app.HomeData[0].status === "recruiting_dropout"
                      ).length
                    })`}
                  </button>
                  <button
                    className={
                      filterType === "withdrawn"
                        ? "btn btn-sm btn-success me-2 mb-2"
                        : "btn btn-sm btn-safy-info me-2 mb-2"
                    }
                    onClick={() => {
                      clearStatusRelatedFilters();
                      setFilterType("withdrawn");
                    }}
                  >
                    {filterCount("Withdrawn")}
                  </button>
                  <button
                    className={
                      filterType === "denied"
                        ? "btn btn-sm btn-success me-2 mb-2"
                        : "btn btn-sm btn-safy-info me-2 mb-2"
                    }
                    onClick={() => {
                      clearStatusRelatedFilters();
                      setFilterType("denied");
                    }}
                  >
                    {filterCount("Denied")}
                  </button>
                  <button
                    className={
                      filterType === "closed"
                        ? "btn btn-sm btn-success me-2 mb-2"
                        : "btn btn-sm btn-safy-info me-2 mb-2"
                    }
                    onClick={() => {
                      clearStatusRelatedFilters();
                      setFilterType("closed");
                    }}
                  >
                    {filterCount("Closed")}
                  </button>
                </>
              ) : null}
              {safyInfo.user.modules.includes("Admin") ? (
                <button
                  className="btn btn-sm border me-2 mb-2"
                  onClick={() => setAllStatuses(!allStatuses)}
                >
                  ...
                </button>
              ) : null}
            </div>
            <ExpandDiv
              className="mt-2"
              label="Additional Filters"
              title="Filters"
            >
              <div className="d-flex flex-wrap">
                <button
                  className={getAdditionalFilterClass("NCD-PAST")}
                  onClick={() => addRemoveAdditionalFilter("NCD-PAST")}
                >
                  Next Contact Date in Past
                </button>
                <button
                  className={getAdditionalFilterClass("NCD-7")}
                  onClick={() => addRemoveAdditionalFilter("NCD-7")}
                >
                  Next Contact Date In Next 7 Days
                </button>
                <button
                  className={getAdditionalFilterClass("LCD-30")}
                  onClick={() => addRemoveAdditionalFilter("LCD-30")}
                >
                  Last Contact Date More Than 30 Days
                </button>
                <button
                  className={getAdditionalFilterClass("NOLCD")}
                  onClick={() => addRemoveAdditionalFilter("NOLCD")}
                >
                  No Contact
                </button>
                <button
                  className={getAdditionalFilterClass("TRAINING")}
                  onClick={() => addRemoveAdditionalFilter("TRAINING")}
                >
                  In Training
                </button>
                {filterType === "applying" || filterType === "" ? (
                  <>
                    <button
                      className={getAdditionalFilterClass("ALD-PAST30")}
                      onClick={() => addRemoveAdditionalFilter("ALD-PAST30")}
                    >
                      Approval Date Estimate Last 30 Days
                    </button>
                    <button
                      className={getAdditionalFilterClass("ALD-30")}
                      onClick={() => addRemoveAdditionalFilter("ALD-30")}
                    >
                      Approval Date Estimate in Next 30 Days
                    </button>
                  </>
                ) : null}
                {filterType === "In Renewal" || filterType === "" ? (
                  <>
                    <button
                      className={getAdditionalFilterClass("RECERT-60")}
                      onClick={() => addRemoveAdditionalFilter("RECERT-60")}
                    >
                      Recert Date in Next 60 Days
                    </button>
                  </>
                ) : null}
              </div>
              <div className="mt-2">Tags</div>
              <div className="d-flex flex-wrap">
                {availableTags.map((tag, index) => (
                  <button
                    key={`tag-${index}`}
                    className={getTagFilterClass(tag)}
                    onClick={() => addRemoveTagFilter(tag)}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </ExpandDiv>
          </div>

          <div className="row g-2 mt-2">
            <div className="col-12 col-md-6 mb-2">
              <Select
                name="sortType"
                label="Sort by"
                onChange={(e) => {
                  setSortType(e.currentTarget.value);
                }}
                options={[
                  { name: "Newest", _id: "newest" },
                  { name: "Name Ascending", _id: "nameAscending" },
                  { name: "Name Descending", _id: "nameDescending" },
                  {
                    name: "Last Contact Date Ascending",
                    _id: "lastContactDateAscending",
                  },
                  {
                    name: "Last Contact Date Descending",
                    _id: "lastContactDateDescending",
                  },
                  {
                    name: "Days in Status Ascending",
                    _id: "daysInStatusAscending",
                  },
                  {
                    name: "Days in Status Descending",
                    _id: "daysInStatusDescending",
                  },
                  {
                    name: "Days Since Inquiry Ascending",
                    _id: "daysSinceInquiryAscending",
                  },
                  {
                    name: "Days Since Inquiry Descending",
                    _id: "daysSinceInquiryDescending",
                  },
                ]}
                value={sortType}
              ></Select>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end align-items-center">
              <div className="d-flex flex-wrap gap-2">
                <div
                  className="btn btn-primary"
                  onClick={() => {
                    navigate(`/BulkCaseNotes`);
                  }}
                >
                  Bulk Case Notes
                </div>
                <AddApplication state={selectedState} />
              </div>
            </div>
          </div>

          <div className="mt-4">
            {filteredData.map((application, index) => (
              <DynamicHome
                key={`${application.id}-${index}`}
                application={application}
                availableTags={availableTags}
                refreshData={() => {
                  console.log("Refreshing Data");
                  setRefreshData(true);
                  setYpos(window.scrollY);
                }}
                index={index}
              ></DynamicHome>
            ))}
          </div>
        </>
      ) : null}
    </>
  );
}

export default SAFYHomes;
